import { useEffect } from 'react';
import { useFeatureFlag } from '../feature-flag';
import { disableSameOriginRequests } from './query-consts';

const DISABLE_SAME_ORIGIN_KEY =
  'im-platformcore-config-sameoriginrequests-isdisabled';

export const SameOriginApiSwitch = () => {
  const { isReady, value } = useFeatureFlag(DISABLE_SAME_ORIGIN_KEY);

  useEffect(() => {
    if (isReady && value === 'true') {
      if (localStorage.getItem(disableSameOriginRequests) === 'true') return;

      localStorage.setItem(disableSameOriginRequests, 'true');
      window.location.reload();
    }
  }, [isReady, value]);

  return null;
};
